import raw from "../../rawClients/rawCapiClient";
import routes from "../../capiRoutes";
export default {
  /** Returns all groups on a project. */
  getAll(projectUid, params) {
    return raw.getAll(routes.groups.allInProject(projectUid), params);
  },
};
